export function getFcEaId(profile = {}) {
  return String(profile?.gameAccounts?.fc?.eaId || profile?.eaId || "").trim();
}

export function getConsoleId(profile = {}) {
  return String(profile?.consoleId || "").trim();
}

export function getMissingPlayerProfileFields(profile = {}) {
  const missing = [];
  if (!getFcEaId(profile)) missing.push("eaId");
  if (!getConsoleId(profile)) missing.push("consoleId");
  return missing;
}

export function hasRequiredPlayerProfileFields(profile = {}) {
  return getMissingPlayerProfileFields(profile).length === 0;
}
